import { debounce, DebouncedFunc } from "lodash-es";

import ApplicationController from "../application_controller";
import DropdownController from "../common/dropdown_controller";

import Stimulus from "../../helpers/stimulus";

export default class InstantSearchController extends ApplicationController {
  static targets = ["form", "resultsDropdown"];

  declare readonly formTarget: HTMLFormElement;
  declare readonly resultsDropdownTarget: HTMLElement;

  debouncedSearch!: DebouncedFunc<() => void>;

  connect() {
    this.debouncedSearch = debounce(() => this.formTarget.requestSubmit(), 300, { leading: true });
  }

  search(event: StimulusEvent) {
    const input = event.currentTarget as HTMLInputElement;

    if (input.value === "") {
      this.hideResultsMenu();
    } else {
      this.showResultsMenu();
      this.debouncedSearch();
    }
  }

  hideResultsMenu() {
    Stimulus.getController(this.resultsDropdownTarget, DropdownController)!.hide();
  }

  showResultsMenu() {
    Stimulus.getController(this.resultsDropdownTarget, DropdownController)!.show(this.formTarget, {
      placement: "bottom",
    });
  }
}
